<template>
    <div class="textfield-container">
        <textarea
            type="text"
            :name="name"
            class="textarea"
            :class="[inputClass, overflow ? 'overflow-input' : '']"
            :rows="rows"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value, $event)"
            @focus="$emit('focus', $event.target.value)"
            @blur="$emit('blur', $event.target.value)"
            @keydown.ctrl.enter="$event.target.blur(), $emit('ctrlEnter', $event.target.value)"
            @keydown.enter="$emit('enter', $event.target.value)"
            @keydown="$emit('keydown', $event)"
            @keyup="$emit('keyup', $event)"
            @cut="$emit('cut', $event)"
            :value="value"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
        />
        <CopyBtn
            v-if="copyBtn"
            :value="value"
        />
    </div>
</template>

<script>
import CopyBtn from "@/components/atoms/CopyBtn.vue";

export default {
    name: "TextArea",
    props: {
        name: String,
        rows: Number,
        inputClass: {
            type: String,
            default: "",
        },
        placeholder: String,
        value: String,
        required: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        copyBtn: {
            type: Boolean,
            default: false
        },
        overflow: {
            type: Boolean,
            default:false
        }
    },
    components: {CopyBtn}
};
</script>

<style scoped lang="scss">
.textfield-container {
    position: relative;
    .textarea {
        font-size: 16px;
        text-align: left;
        border-radius: 6px;
        width: 100%;
        display: block;
        padding: 10px;
        background: var(--secondary-bg);
        border: 0.5px solid var(--outline);
        color: var(--primary-text);
        display: block;
        resize: none;
        
        &:disabled {
            border-radius: 0px;
            border: none;
            background-color: #f2f2f2;
            font-size: normal;
            text-align: left;
            margin-bottom: 12px;
            width: 100%;
            display: block;
            padding: 10px;
            color: var(--secondary-text);
        }

        &:focus-visible {
            outline: none;
            border: 0.5px solid var(--outline-active);
        }

        &::placeholder {
            color: var(--placeholder);
        }
    }

    .overflow-input {
        overflow-y: hidden;
    }
}
</style>
